export const SIGN_UP = '/signup';
export const SIGN_IN = '/';
export const HOME = '/home';
export const PASSWORD_FORGET = '/pw-forget';